import script from "./PurchaseList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PurchaseList.vue?vue&type=script&lang=ts&setup=true"

import "./PurchaseList.vue?vue&type=style&index=0&id=7bb9e1f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb9e1f2"]])

export default __exports__